export enum TransactionFlowType {
  Remove,
  Logout,
  GoHome,
  Pay,
}
